import React from "react";
import PropTypes from "prop-types";

/**
 * BadgeOverlay - Positions badge elements over card images
 * Supports multiple predefined positions
 * 
 * @component
 * @example
 * <BadgeOverlay position="top-right">
 *   <Badge variant="primary">Featured</Badge>
 * </BadgeOverlay>
 */
const BadgeOverlay = ({
    position = "top-right",
    children,
    className = "",
}) => {
    const positions = {
        "top-right": "absolute top-4 right-4 z-10",
        "top-left": "absolute top-4 left-4 z-10",
        "bottom-right": "absolute bottom-2 right-3 z-10",
        "bottom-left": "absolute bottom-2 left-3 z-10",
    };

    return (
        <div className={`${positions[position]} ${className}`}>
            {children}
        </div>
    );
};

BadgeOverlay.propTypes = {
    position: PropTypes.oneOf(["top-right", "top-left", "bottom-right", "bottom-left"]),
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export default BadgeOverlay;
